import { graphql, StaticQuery } from "gatsby"
import React, { Component } from "react"

import EducationTile from "./widgets/EducationTile"

import * as educationStyles from "../styles/education.module.css"


class Education extends Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query EducationQuery {
            dataJson(title: { eq: "Education" }) {
              courses {
                course
                location
                name
                year
                img {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        `}
        render={data => (
          <React.Fragment>
            <div
              className="container"
              data-sal="fade"
              data-sal-delay="50"
              data-sal-easing="ease"
            >
              <div className={educationStyles.divider}></div>
              <div className={educationStyles.title}>
                {/* {data.markdownRemark.frontmatter.title} */}
                EDUCATION
                <div className={educationStyles.desc}>
                  &lt;COLLEGE & COURSES/&gt;
                </div>
              </div>
              <div className={`row ${educationStyles.row}`}>
                {data.dataJson.courses.map(course => (
                  <EducationTile
                    key={course.name}
                    degree={course.name}
                    institute={course.course}
                    location={course.location}
                    year={course.year}
                    fluid={course.img.childImageSharp.fluid}
                  />
                ))}
              </div>
            </div>
          </React.Fragment>
        )}
      />
    )
  }
}
export default Education
